export const CLAIMS_UPDATE_OVERWATCH = 'OD/CLAIMS_UPDATE_OVERWATCH'

export const raiseClaimsUpdated = () => ({
  type: CLAIMS_UPDATE_OVERWATCH,
})

